// OS detection for the install picker's default tab.

export type Platform = "unix" | "windows";

export function detectPlatform(): Platform {
  const nav = navigator as Navigator & {
    userAgentData?: { platform?: string };
  };
  if (nav.userAgentData?.platform) {
    return nav.userAgentData.platform.toLowerCase().includes("windows")
      ? "windows"
      : "unix";
  }
  const p = (navigator.platform || "").toLowerCase();
  return p.startsWith("win") ||
    navigator.userAgent.toLowerCase().includes("windows")
    ? "windows"
    : "unix";
}
